export enum HierarchyTreeDataType {
    COLLECTIONS = "Collections",
    FOLDER = "Folder",
    LABELS = "Labels",
    LAYERS = "Layers",
    QUERIES = "GraphQueries",
    REFERENCE = "Reference",
}
